import { Enums } from '../common/enums'

import { IJsonSerializable } from '../util/interfaces'

import { OpTaskStatus } from '../core/op-task-status'

import { TypeHelper } from '../../helpers/type-helper'

export class OpTaskStatusFlow implements IJsonSerializable {

    // Members

    public taskStatus: OpTaskStatus = null
    public changeStatus: OpTaskStatus[] = []

    // Members


    // Ctor

    public constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    // Ctor End


    // IJsonSerializable Implementation
    
    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj != null) {

            if (compressed || TypeHelper.isJSONCompressed(opObj)) {
                this.taskStatus = opObj.TaskStatus != null ? new OpTaskStatus(opObj.T) : null
                this.changeStatus = opObj.ChangeStatus != null ? opObj.C.map((taskStatusObj: any) => new OpTaskStatus(taskStatusObj)) : null
            } 
            else {
                this.taskStatus = opObj.TaskStatus != null ? new OpTaskStatus(opObj.TaskStatus) : null
                this.changeStatus = opObj.ChangeStatus != null ? opObj.ChangeStatus.map((taskStatusObj: any) => new OpTaskStatus(taskStatusObj)) : null
            }
        }
    }

    public toJSON(compressed: boolean = false): any {
        if (compressed) {
            const result: any = {
                T: this.taskStatus != null ? this.taskStatus.toJSON(true) : null,
                C: this.changeStatus != null ? this.changeStatus.map((taskStatus: OpTaskStatus) => taskStatus.toJSON(compressed)) : null,
            }

            TypeHelper.setJSONCompressedFlag(result)
            TypeHelper.deleteNulls(result)

            return result
        } 

        return {
            TaskStatus: this.taskStatus != null ? this.taskStatus.toJSON() : null,
            ChangeStatus: this.changeStatus != null ? this.changeStatus.map((taskStatus: OpTaskStatus) => taskStatus.toJSON(compressed)) : null
        }
    }

    // IJsonSerializable Implementation End
}